import { BenefitsSettingsAction, BenefitsSettingsState } from '../benefits-settings-store';

export const setBenefitsSettingsStateAction =
    (partialState: Partial<BenefitsSettingsState>): BenefitsSettingsAction =>
    ({ setState }) => {
        setState(partialState);
    };
